module.exports = __webpack_public_path__ + "static/media/close-blue.57ee4445.svg";